import v2 from './v2.js';
function ledger(options) {
    return v2(options);
}
export default ledger;
